import React, { FC } from 'react';

import { ILang, useTranslation } from '~shared/lib/i18n';

import { CertificateWarningIcon, Empty, FileIconLandscape } from '~shared/ui';
import { IProfile, NarcologyRecord } from '~entities/kindergarten/profile';

export interface ProfileCertificateViewProps {
  profile: IProfile | null;
}

export const ProfileCertificateView: FC<ProfileCertificateViewProps> = ({ profile }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language as ILang;

  const getTranslateRecord = (record: NarcologyRecord, key: string): string => {
    // @ts-ignore
    return record[`${key}_${lang}` as `${key}_ru` | `${key}_ky`];
  };

  if (!profile) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  return (
    <>
      <div className="text-[20px] ">{t('profile:reference')}</div>
      <div className="flex pt-3">
        <div className="pr-5">
          <CertificateWarningIcon />
        </div>
        <div className="text-[12px]">
          {`${t('profile:salutation')} ${profile.name}, ${t('profile:salutationText')}`}
        </div>
      </div>
      {profile?.reference.map((docs, idx) => (
        <div className="flex pt-4" key={idx}>
          <div className="pr-5 mt-1">
            <FileIconLandscape stroke="var(--stroke)" />
          </div>
          <div className="pt-0">
            <div className="text-[15px] font-bold pb-3 pt-0">
              {getTranslateRecord(docs, 'title')}
            </div>
            <div className="grid grid-cols-1 text-[15px] gap-1">
              <div>
                <span className="text-[#4A4A4A]">{t('docs.org_name')}: </span>
                {getTranslateRecord(docs, 'organization_service')}
              </div>
              <div>
                <span className="text-[#4A4A4A]">{t('docs.result')}: </span>
                {getTranslateRecord(docs, 'status')}
              </div>
              <div>
                <span className="text-[#4A4A4A]">{t('docs.date')}</span>: {docs.date}
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
